export const reportTableTheme = {
  border: "1px solid #e0e0e0",
  headerBg: "#f2f2f2",
  headerText: "#616161",
  dateColumnWidth: 100,
  cellPaddingY: 1,
  cellPaddingX: 1,
  priceCellPaddingX: "6px",
  priceCellPaddingY: "4px",
  cellMinHeight: 30,
  cellMaxHeight: 30,
  darkHeaderBg: "#1e2a3a",
  darkHeaderText: "#ffffff",
  priceFontSize: "14px",
  defaultPriceColor: "#000000",
  deltaFontSize: "12px",
  cellBgDown: "#ffdada",
  cellBgUp: "#c6efce",
  deltaColorUp: "#1B5E20",
  rowHoverDarkenMix: "92%",
} as const;

export const reportCellInnerSx = {
  minHeight: reportTableTheme.cellMinHeight,
  maxHeight: reportTableTheme.cellMaxHeight,
  py: reportTableTheme.cellPaddingY,
  px: reportTableTheme.cellPaddingX,
  boxSizing: "border-box" as const,
} as const;

export const priceCellInnerSx = {
  minHeight: reportTableTheme.cellMinHeight,
  maxHeight: reportTableTheme.cellMaxHeight,
  py: reportTableTheme.priceCellPaddingY,
  px: reportTableTheme.priceCellPaddingX,
  boxSizing: "border-box" as const,
} as const;

export const reportBodyCellTdSx = {
  border: reportTableTheme.border,
  p: 0,
  verticalAlign: "middle" as const,
} as const;

export function reportCellBackground(color: string) {
  return {
    backgroundColor: color,
    "--cell-bg": color,
  };
}

export const reportRowHoverSx = {
  "&:hover td": {
    backgroundColor: `color-mix(in srgb, var(--cell-bg, #ffffff) ${reportTableTheme.rowHoverDarkenMix}, #000000)`,
  },
} as const;
